

import * as React from 'react';

import cn from 'classnames';

import styles from './search-criteria.module.css';

import Accordion, { type AccordionPanelProps } from './accordion/Accordion';

export type SearchCriteriaProps = {
  id: string,
  title: string,
  children: React.ReactNode,
};

const SearchCriteria = (props: SearchCriteriaProps) => {
  const parent: AccordionPanelProps = {
    id: 'parent',
    title: <Title title={props.title} />,
    show: true,
    children: props.children,
    panelClassName: styles.panelBody,
  };

  return <Accordion id={props.id} panels={[parent]} />;
};

type TitleProps = {
  title: string,
};

const Title = (props: TitleProps) => (
  <div className={cn(styles.titleText)}>{props.title}</div>
);

export default SearchCriteria;
